declare const $: any;

export function closePopup(): void {
  $.magnificPopup.close();
}
